// extracted by mini-css-extract-plugin
export var cardSelected = "_j9-2";
export var image = "_j9-1";
export var table = "_j9-0";